import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { CustomerAuthProvider } from './context/CustomerAuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import AgeGate from './components/AgeGate';
import CartSync from './components/CartSync';
import RegisterPromoModal from './components/RegisterPromoModal';
import HomePage from './pages/HomePage';
import HookahsPage from './pages/HookahsPage';
import SetsPage from './pages/SetsPage';
import AccessoriesPage from './pages/AccessoriesPage';
import SalePage from './pages/SalePage';
import ProductPage from './pages/ProductPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import AdminPage from './pages/AdminPage';
import WishlistPage from './pages/WishlistPage';
import SearchPage from './pages/SearchPage';
import WarrantyPage from './pages/WarrantyPage';
import BestsellersPage from './pages/BestsellersPage';
import AccountPage from './pages/AccountPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
        <WishlistProvider>
          <CustomerAuthProvider>
          <BrowserRouter>
            <div className="min-h-screen bg-black flex flex-col">
              <AgeGate />
              <RegisterPromoModal />
              <CartSync />
              <Header />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/hookahs" element={<HookahsPage />} />
                  <Route path="/sets" element={<SetsPage />} />
                  <Route path="/accessories" element={<AccessoriesPage />} />
                  <Route path="/sale" element={<SalePage />} />
                  <Route path="/product/:id" element={<ProductPage />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/wishlist" element={<WishlistPage />} />
                  <Route path="/search" element={<SearchPage />} />
                  <Route path="/warranty" element={<WarrantyPage />} />
                  <Route path="/bestsellers" element={<BestsellersPage />} />
                  <Route path="/account" element={<AccountPage />} />
                  <Route path="/reset-password" element={<ResetPasswordPage />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </BrowserRouter>
          </CustomerAuthProvider>
        </WishlistProvider>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
